// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"296":"8e84667ba4d903e4","9464":"5fb4eaaa99477123","9894":"df6dba095f8d61ef"}[chunkId] + ".js";
};